module.exports = __webpack_public_path__ + "mer/fonts/iconfont.3bb04b23.woff";